import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { NavPills } from '@totalsoft/rocket-ui';
import { useReactiveVar } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { globalIsDirtyVar } from '../variables';

const NavPillsWithPrompt = ({ active, onChange, ...rest }) => {
  const { t } = useTranslation();

  const globalIsDirty = useReactiveVar(globalIsDirtyVar);

  const [internalActive, setInternalActive] = useState(active);

  useEffect(() => {
    setInternalActive(active);
  }, [active]);

  return (
    <>
      <NavPills
        {...rest}
        active={internalActive}
        onChange={(_event, value) => {
          if (globalIsDirty && !window.confirm(t('LeavingWithoutSaving'))) return;
          setInternalActive(value);
          onChange && onChange(_event, value);
        }}
      />
    </>
  );
};

NavPillsWithPrompt.propTypes = {
  active: PropTypes.number,
  onChange: PropTypes.func
};

export default NavPillsWithPrompt;
